import { getSrcSet } from "../../Helpers/WindowHelpers";
import Media from "../../Interfaces/MediaInterface";

interface ImageInterface {
    image: Media,
    srcSet: number[],
    sizes: string,
    classes?: string
}

const Image = ({ image, srcSet, sizes, classes }: ImageInterface) => {
    return <img
        className={classes ? classes : ''}
        srcSet={getSrcSet(image.src, srcSet)}
        sizes={sizes}
        src={image.src}
        loading="lazy"
        alt={image.alt}
    />
}

export default Image